import { render } from "./AdminFormIQ3Page.vue?vue&type=template&id=ca84f2e0&scoped=true"
import script from "./AdminFormIQ3Page.vue?vue&type=script&lang=js"
export * from "./AdminFormIQ3Page.vue?vue&type=script&lang=js"

import "../forms/form.css?vue&type=style&index=0&id=ca84f2e0&scoped=true&lang=css&external"
import "./AdminFormIQ3Page.vue?vue&type=style&index=1&id=ca84f2e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca84f2e0"]])

export default __exports__